import React, { useEffect } from 'react'
import '.././App.css';
import { auth } from '../firebase';

function Header() {

    const signOut = () => {
        auth.signOut();
        window.location.href = "/login";
    }
    useEffect(() => {
        auth.onAuthStateChanged((user) => {
        });
    });



    return (
        <div>

            <nav className="main-header navbar navbar-expand navbar-orange navbar-light" style={{backgroundColor:"#b403aeff"}}>
                {/* Left navbar links */}
                <ul className="navbar-nav">
                    <li className="nav-item">
                        <a className="nav-link" data-widget="pushmenu" href="#0" role="button"><i style={{ color: "white" }} className="fas fa-bars" /></a>
                    </li>
                    <li className="nav-item">
                        <a className="nav-link" href="#0" >
                            <b style={{ color: "white", textTransform: "uppercase" }}> DASARA EXECUTIVE </b>
                        </a>
                    </li>

                </ul>
                {/* Right navbar links */}
                <ul className="navbar-nav ml-auto">
                  
                    {/* <li className="nav-item">
                        <a className="nav-link" data-widget="control-sidebar" data-slide="true" href="#0" role="button">
                            <i className="fas fa-th-large" />
                        </a>
                    </li> */}
                    <li className="nav-item">
                        <a className="nav-link" href="javascript:history.go(-1)">
                            <i style={{ color: "white" }} className="fas fa-backward" />
                        </a>
                    </li>
                    <li className="nav-item">
                        <a className="nav-link" href="javascript:history.go(+1)">
                            <i style={{ color: "white" }} className="fas fa-forward" />
                        </a>
                    </li>
                    <li className="nav-item">
                        <a className="nav-link" onClick={() => signOut()} href="#0">
                            <i style={{ color: "white" }} className="fa fa-sign-out" />
                        </a>
                    </li>
                </ul>
            </nav>
        </div>
    )
}
export default Header